module.exports = __webpack_public_path__ + "img/enterprise.89691f1.svg";